import React from 'react';
import { Helmet } from 'react-helmet-async';
import './styles/HeroSection.css';

const HeroSection = ({ data }) => {
  return (
    <section className='location-hero'>
      <Helmet>
        <title>{data?.seo?.title}</title>
        <meta name='description' content={data?.seo?.description} />
        <link rel='canonical' href={data?.seo?.canonical} />
      </Helmet>
      <div className='location-hero-content'>
        <h1 className='location-hero-title'>{data?.heroTitle}</h1>
        <p className='location-hero-address'>
          <img src={'/location-dot.svg'} alt='' className='location-hero-image' />
          {data?.heroDescription}
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
